module.exports = __webpack_public_path__ + "img/time-funnel_green.0c75292d.png";